import { render, staticRenderFns } from "./StatementsSafety.vue?vue&type=template&id=745925d7&scoped=true"
import script from "./StatementsSafety.vue?vue&type=script&lang=js"
export * from "./StatementsSafety.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745925d7",
  null
  
)

export default component.exports